// Novo useUserDataPreFill.js (refatorado)
import { useEffect } from 'react';
import phoneMaskArray from 'js/components/DesignSystem/phoneMaskArray.json';
import { GetUserPartner } from 'js/library/utils/API/apiGetUserPartner';

export default function useUserDataPreFill({
  userData,
  clubForms,
  formFields,
  setPartnerData,
  setCellPhone,
  setInputMask,
  setCurrentCountry,
  setCurrentDDD,
  setLoading,
}) {
  useEffect(() => {
    async function fetchUserData() {
      if (!userData?.uId?.value || !clubForms?.partnerId) return;

      setLoading(true);

      try {
        const response = await GetUserPartner(clubForms.partnerId, userData.uId.value);
        const structuredUser = response?.response;
        if (!structuredUser) return;

        const partnerData = { ...structuredUser };

        // trata data para exibir no campo
        formFields.forEach((field) => {
          const { fieldName, inputType, fieldType, type } = field;

          if (type === 'contactList' && Array.isArray(structuredUser.contactList)) {
            const match = structuredUser.contactList.find((i) => i.type === fieldName);
            if (match) {
              partnerData[fieldName] = match.value;
              if (fieldType === 'cellPhone') {
                const raw = match.value.replace(/\D/g, '').replace(/^55/, '');
                const matchDDD = phoneMaskArray.find((p) => match.value.startsWith(p.ddd));
                if (matchDDD) {
                  setCurrentCountry(`${matchDDD.ddd},${matchDDD.mask},${matchDDD.fullMask}`);
                  setInputMask(matchDDD.mask);
                  setCurrentDDD(matchDDD.ddd);
                }
                setCellPhone(raw);
              }
            }
          }

          if (type === 'documentList' && Array.isArray(structuredUser.documentList)) {
            const match = structuredUser.documentList.find((i) => i.type === fieldName);
            if (match) partnerData[fieldName] = match.value;
          }

          if (type === 'optInList' && Array.isArray(structuredUser.optInList)) {
            const match = structuredUser.optInList.find((i) => i.optInId === fieldName);
            if (match) partnerData[fieldName] = match;
          }

          if (type === 'addressList' && structuredUser.addressList?.[0]) {
            const addr = structuredUser.addressList[0];
            partnerData.zipCode = addr.zipCode;
            partnerData.streetAve = addr.streetAve;
            partnerData.streetNumber = addr.streetNumber;
            partnerData.neighborhood = addr.neighborhood;
            partnerData.city = addr.city;
            partnerData.state = addr.state;
            partnerData.complement = addr.extra;
          }

          if ((inputType === 'date' || fieldType === 'date') && structuredUser[fieldName]) {
            const ts = structuredUser[fieldName];
            const timestamp = ts < 9999999999 ? ts * 1000 : ts;
            partnerData[fieldName] = new Date(timestamp).toISOString().split('T')[0];
          }
        });

        setPartnerData(partnerData);
      } catch (err) {
        console.error('Erro ao buscar dados com GetUserPartner', err);
      } finally {
        setLoading(false);
      }
    }

    fetchUserData();
  }, [userData, clubForms]);
}
